import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

export enum OrderStatus {
  Captured = 'captured',
  Paid = 'paid',
  Failed = 'failed',
  Pending = 'pending',
  WaitingPayment = 'waiting_payment',
  NotAuthorized = 'not_authorized',
}

interface UseCheckOrderResponse {
  data: OrderStatus;
  isLoading: boolean;
}

export const useCheckOrder = (id: number) => {
  const { data, isLoading } = useQuery<UseCheckOrderResponse>({
    queryKey: [clientKeys.useCheckOrder, id],
    queryFn: async () => edupassClient.get(`/orders/${id}`),
    refetchInterval: ({ state }) => {
      const status = state.data?.data;
      const pending =
        status === OrderStatus.Pending || status === OrderStatus.WaitingPayment;
      return pending ? 7000 : false;
    },
    gcTime: 0,
    staleTime: 0,
    enabled: !!id,
  });

  const isSuccess =
    data?.data === OrderStatus.Captured || data?.data === OrderStatus.Paid;
  const isFailed =
    data?.data === OrderStatus.Failed ||
    data?.data === OrderStatus.NotAuthorized;

  return {
    isLoading,
    isSuccess,
    isFailed,
  };
};
